module.exports = __webpack_public_path__ + "img/2_274.e4391397.png";